"use strict";
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useMethods = void 0;
var react_1 = require("react");
var useOrderAndSplitPaymentMethodsByGEO_1 = __importDefault(require("./useOrderAndSplitPaymentMethodsByGEO"));
var useMethods = function (_a) {
    var paymentSettings = _a.paymentSettings, methods = _a.methods, country = _a.country;
    var orderAndSplitPaymentMethodsByGEO = (0, useOrderAndSplitPaymentMethodsByGEO_1.default)(paymentSettings, country);
    return (0, react_1.useMemo)(function () {
        var orderedMethods = orderAndSplitPaymentMethodsByGEO(methods);
        return __spreadArray(__spreadArray([], orderedMethods['withSetup'], true), orderedMethods['additional'], true);
    }, [orderAndSplitPaymentMethodsByGEO, methods]);
};
exports.useMethods = useMethods;
